import { OptsErrorModal } from '@interfaces/*';

export const errors = [
  {
    _errorDescription: 'Generic system error',
    code: '0',
    en_US: {
      title: 'System Error!',
      message: 'Unknown error.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'Error desconocido.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: '不明なエラー.',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '알수없는 오류.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '未知错误.',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message: 'Onbekende fout.',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: 'Erro desconhecido.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: 'Erreur inconnu.',
    },
  },
  {
    _errorDescription: 'Generic validation error',
    code: '1',
    en_US: {
      title: 'Validation Error!',
      message: 'Unknown error.',
    },
    es_MX: {
      title: 'Validation Error!',
      message: 'Error desconocido.',
    },
    ja_JP: {
      title: 'Validation Error!',
      message: '不明なエラー.',
    },
    kr_KR: {
      title: 'Validation Error!',
      message: '알수없는 오류.',
    },
    zh_CN: {
      title: 'Validation Error!',
      message: '未知错误.',
    },
    du_NL: {
      title: 'Validation Error!',
      message: 'Onbekende fout.',
    },
    pt_PT: {
      title: 'Validation Error!',
      message: 'Erro desconhecido.',
    },
    fr_FR: {
      title: 'Validation Error!',
      message: 'Erreur inconnu.',
    },
  },
  {
    code: '10',
    en_US: {
      title: 'System Error!',
      message: "You can't add more bags, because payment is not enabled.",
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: "You can't add more bags, because payment is not enabled.",
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: "You can't add more bags, because payment is not enabled.",
    },
    kr_KR: {
      title: '죄송합니다!',
      message: "You can't add more bags, because payment is not enabled.",
    },
    zh_CN: {
      title: '很抱歉！',
      message: "You can't add more bags, because payment is not enabled.",
    },
    du_NL: {
      title: 'Het spijt ons!',
      message: "You can't add more bags, because payment is not enabled.",
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: "You can't add more bags, because payment is not enabled.",
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: "You can't add more bags, because payment is not enabled.",
    },
  },
  {
    code: '206003',
    en_US: {
      title: 'We are sorry!',
      message:
        'We have not found your booking with the information entered. Please check that it is correct and try again. Remember that you have other options to find your booking.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message:
        'No hemos encontrado tu reserva con la información ingresada. Por favor revisa que sea correcta e inténtalo de nuevo. Recuerda que cuentas con otras opciones para encontrar tu reserva',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message:
        '入力された情報ではご予約が見つかりませんでした。入力された内容が正しいことをご確認し、もう一度ご入力ください。ご予約を検索する方法はまだ他にもあります。',
    },
    kr_KR: {
      title: '미안합니다',
      message:
        '귀하가 입력한 예약정보를 찾을 수 없습니다. 입력하신 정보가 정확한지 확인하시고 새로 입력하십시오. 귀하의 예약번호를 찾을 수 있는 다른 옵션이 있다는 사실을 잊지 마십시오.',
    },
    zh_CN: {
      title: '对不起！',
      message: '根据您输入的信息，我们没有找到您的预订。请检查无误后再试或使用其他方式查找预订',
    },
    du_NL: {
      title: '¡Het spijt ons!',
      message:
        'We hebben je reservering niet gevonden met de opgegeven informatie. Controleer of de informatie correct is en probeer het opnieuw. Onthoud dat je andere opties hebt om je reservering te vinden.',
    },
    pt_PT: {
      title: 'Desculpe!',
      message:
        'Não encontramos sua reserva com as informações digitadas. Revise que os dados sejam corretos e tente novamente. Lembre-se que existem diversas opções para encontrar sua reserva.',
    },
    fr_FR: {
      title: 'Désolé !',
      message:
        "Nous n'avons pas trouvé votre réservation avec les informations que vous avez saisies. Veuillez vérifier qu'elles sont correctes et réessayer. N'oubliez pas que vous disposez d'autres moyens pour trouver votre réservation.",
    },
  },
  {
    code: '22530302',
    en_US: {
      title: 'We are sorry!',
      message:
        'We have not found your booking with the information entered. Please check that it is correct and try again. Remember that you have other options to find your booking.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message:
        'No hemos encontrado tu reserva con la información ingresada. Por favor revisa que sea correcta e inténtalo de nuevo. Recuerda que cuentas con otras opciones para encontrar tu reserva',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message:
        '入力された情報ではご予約が見つかりませんでした。入力された内容が正しいことをご確認し、もう一度ご入力ください。ご予約を検索する方法はまだ他にもあります。',
    },
    kr_KR: {
      title: '미안합니다',
      message:
        '귀하가 입력한 예약정보를 찾을 수 없습니다. 입력하신 정보가 정확한지 확인하시고 새로 입력하십시오. 귀하의 예약번호를 찾을 수 있는 다른 옵션이 있다는 사실을 잊지 마십시오.',
    },
    zh_CN: {
      title: '对不起！',
      message: '根据您输入的信息，我们没有找到您的预订。请检查无误后再试或使用其他方式查找预订',
    },
    du_NL: {
      title: '¡Het spijt ons!',
      message:
        'We hebben je reservering niet gevonden met de opgegeven informatie. Controleer of de informatie correct is en probeer het opnieuw. Onthoud dat je andere opties hebt om je reservering te vinden.',
    },
    pt_PT: {
      title: 'Desculpe!',
      message:
        'Não encontramos sua reserva com as informações digitadas. Revise que os dados sejam corretos e tente novamente. Lembre-se que existem diversas opções para encontrar sua reserva.',
    },
    fr_FR: {
      title: 'Désolé !',
      message:
        "Nous n'avons pas trouvé votre réservation avec les informations que vous avez saisies. Veuillez vérifier qu'elles sont correctes et réessayer. N'oubliez pas que vous disposez d'autres moyens pour trouver votre réservation.",
    },
  },
  {
    code: '204131',
    en_US: {
      title: 'We are sorry!',
      message:
        'We have not found your booking with the information entered. Please check that it is correct and try again. Remember that you have other options to find your booking.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message:
        'No hemos encontrado tu reserva con la información ingresada. Por favor revisa que sea correcta e inténtalo de nuevo. Recuerda que cuentas con otras opciones para encontrar tu reserva',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message:
        '入力された情報ではご予約が見つかりませんでした。入力された内容が正しいことをご確認し、もう一度ご入力ください。ご予約を検索する方法はまだ他にもあります。',
    },
    kr_KR: {
      title: '미안합니다',
      message:
        '귀하가 입력한 예약정보를 찾을 수 없습니다. 입력하신 정보가 정확한지 확인하시고 새로 입력하십시오. 귀하의 예약번호를 찾을 수 있는 다른 옵션이 있다는 사실을 잊지 마십시오.',
    },
    zh_CN: {
      title: '对不起！',
      message: '根据您输入的信息，我们没有找到您的预订。请检查无误后再试或使用其他方式查找预订',
    },
    du_NL: {
      title: '¡Het spijt ons!',
      message:
        'We hebben je reservering niet gevonden met de opgegeven informatie. Controleer of de informatie correct is en probeer het opnieuw. Onthoud dat je andere opties hebt om je reservering te vinden.',
    },
    pt_PT: {
      title: 'Desculpe!',
      message:
        'Não encontramos sua reserva com as informações digitadas. Revise que os dados sejam corretos e tente novamente. Lembre-se que existem diversas opções para encontrar sua reserva.',
    },
    fr_FR: {
      title: 'Désolé !',
      message:
        "Nous n'avons pas trouvé votre réservation avec les informations que vous avez saisies. Veuillez vérifier qu'elles sont correctes et réessayer. N'oubliez pas que vous disposez d'autres moyens pour trouver votre réservation.",
    },
  },
  {
    code: '204131-1',
    en_US: {
      title: 'We are sorry!',
      message:
        'More than one booking was found with the same name. Make your search with any of the following criteria:',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message:
        'Se ha encontrado más de una reserva con el mismo nombre. Realiza tu búsqueda con alguno de los siguientes criterios:',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: '同じお名前で予約が複数見つかりました。次のいずれかの条件で検索してください。',
    },
    kr_KR: {
      title: '미안합니다',
      message: '같은 이름으로 하나 이상의 예약이 발견되었습니다. 다음의 기준에 맞추어 찾으십시오.',
    },
    zh_CN: {
      title: '对不起！',
      message: '您已使用同一个名字搜索预订多次。请使用以下方式进行搜索：',
    },
    du_NL: {
      title: '¡Het spijt ons!',
      message:
        'Er is meer dan één reservering gevonden met dezelfde naam. Voer de zoekopdracht uit met een van de volgende criteria:',
    },
    pt_PT: {
      title: 'Desculpe!',
      message:
        'Mais de uma reserva sob o mesmo nome foi encontrada. Busque com algum dos seguintes critérios:',
    },
    fr_FR: {
      title: 'Désolé !',
      message:
        "Plus d'une réservation a été trouvée sous le même nom. Veuillez effectuer votre recherche en utilisant l'un des critères suivants :",
    },
  },
  {
    code: '204092',
    en_US: {
      title: 'System Error!',
      message:
        'Dear Client,\nOur priority is to provide you with the best service; your flight is presenting high demand and an additional process is needed to conclude your seat assignment;please proceed to our counters',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message:
        'Estimado cliente,\nNuestra prioridad es brindarte el mejor servicio; tu vuelo presenta alta demanda y es necesario un proceso adicional para concluir con la asignación de tus asientos, por favor pasa a nuestros mostradores',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message:
        'お客さま 私たちは、お客様に最高のサービスを提供することを第一に考えています。お客様のフライトが混雑しており、座席指定に追加手続きが必要です。カウンターまでお越しください。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message:
        '승객여러분, 저희는 여러분께 최상의 서비스를 제공하고자 합니다; 귀하가 이용하는 항공편이 만석으로 귀하의 좌석을 지정하기 위해 추가 절차가 필요합니다. 저희 카운터로  오시기 바랍니다.',
    },
    zh_CN: {
      title: '很抱歉！',
      message:
        '各位乘客：\n乘客至上是我们的服务宗旨，鉴于本次航班座位的需求量很大，请到柜台再次办理座位分配。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message:
        'Beste klant,\nHet is onze prioriteit u een zo goed mogelijke service te bieden; er is veel vraag naar uw vlucht en we moeten een extra procedure uitvoeren om uw stoelen toe te wijzen. We verzoeken u naar onze balies te gaan.',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message:
        'Estimado cliente,\nA nossa prioridade é prestar-lhe o melhor serviço. Seu voo está em alta demanda e é necessário um processo adicional para concluir com a atribuição de seus assentos. Dirija-se aos nossos balcões',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        "Cher client,\nNotre priorité est de vous offrir le meilleur service. Votre vol est très demandé et une démarche supplémentaire est nécessaire pour finaliser l'attribution de vos sièges. Merci de vous présenter à nos guichets",
    },
  },
  {
    code: '202005',
    en_US: {
      title: 'System Error!',
      message: 'FREQUENT TRAVELER NUMBER DOES NOT EXIST FOR THIS AIRLINE.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'El número de viajero frecuente  no existe para este programa.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: '常連番号はこの航空会社のものではありません。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '멤버쉽(마일리지)번호를 잘 못 입력하셨습니다.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '飞行常客号码不属于我航空公司。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message: 'FREQUENT TRAVELER NUMMER BESTAAT NIET VOOR DEZE VLIEGTUIGMAATSCHAPPIJ.',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: 'NÚMERO DO PROGRAMA DE FIDELIDADE NÃO EXISTE PARA ESTA COMPANHIA AÉREA.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: "LE NUMÉRO DE GRAND VOYAGEUR N'EXISTE PAS POUR CETTE COMPAGNIE AÉRIENNE.",
    },
  },
  {
    code: '202036',
    en_US: {
      title: 'System Error!',
      message: 'NAME DOES NOT MATCH FREQUENT TRAVELER NUMBER OWNER.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'El nombre ingresado no coincide con el número de viajero frecuente.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: '氏名は常連客の所有者と一致しません.',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '탑승자명이 멤버쉽 이름과 상이합니다.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '姓名不符合飞行常客的所有者.',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message: 'NAAM KOMT NIET OVEREEN MET EIGENAAR VAN FREQUENT TRAVELER NUMMER.',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: 'NOME NÃO CORRESPONDE AO TITULAR DO NÚMERO DO PROGRAMA DE FIDELIDADE.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: 'LE NOM NE CORRESPOND PAS AU TITULAIRE DU NUMÉRO DE GRAND VOYAGEUR.',
    },
  },
  {
    code: '204013',
    en_US: {
      title: '',
      message: 'Unable to reprint boarding pass. Please see an agent at the counter.',
    },
    es_MX: {
      title: '',
      message:
        'No fue posible imprimir el pase de abordar. Por favor acude con un agente en mostrador.',
    },
    ja_JP: {
      title: '',
      message: '搭乗券の印刷ができません。チェックインカウンターのスタッフにご相談ください。',
    },
    kr_KR: {
      title: '',
      message: '탑승권을 재인쇄할 수 없습니다. 카운터에서 여행사 직원에게 문의할 수 있습니다.',
    },
    zh_CN: {
      title: '',
      message: '无法重新打印登机牌。请前往柜台寻找代理人。',
    },
    du_NL: {
      title: '',
      message: 'Instapkaart kan niet opnieuw afgedrukt worden. Vraag hulp aan een baliemedewerker.',
    },
    pt_PT: {
      title: '',
      message:
        'Não foi possível reimprimir o cartão de embarque. Procure um funcionário da empresa no balcão de atendimento.',
    },
    fr_FR: {
      title: '',
      message:
        "Impossible de réimprimer la carte d'embarquement. Veuillez consulter un agent au comptoir.",
    },
  },
  {
    code: '201010',
    en_US: {
      title: '',
      message: 'PASSENGERS ADDED TO THE PRIORITY LIST.',
    },
    es_MX: {
      title: '',
      message: 'Te agregamos a la lista de prioridad.',
    },
    ja_JP: {
      title: '',
      message: '優先リストに追加された乗客.',
    },
    kr_KR: {
      title: '',
      message: '우선순위 리스트에 탑승객이 추가되었습니다.',
    },
    zh_CN: {
      title: '',
      message: '加入优先名单的乘客.',
    },
    du_NL: {
      title: '',
      message: 'PASSAGIERS DIE AAN DE PRIORITYLIJST ZIJN TOEGEVOEGD.',
    },
    pt_PT: {
      title: '',
      message: 'PASSAGEIROS ADICIONADOS À LISTA PRIORITÁRIA.',
    },
    fr_FR: {
      title: '',
      message: 'PASSAGERS AJOUTÉS SUR LA LISTE PRIORITAIRE.',
    },
  },
  {
    code: '205000',
    en_US: {
      title: '',
      message:
        'It is not possible to continue check-in with the information provided. Please proceed to the check-in counter.',
    },
    es_MX: {
      title: '',
      message:
        'No es posible continuar con la información proporcionada por favor, acude mostrador',
    },
    ja_JP: {
      title: '',
      message: 'チェックインを続行できません',
    },
    kr_KR: {
      title: '',
      message: '체크인을 계속할 수 없습니다.',
    },
    zh_CN: {
      title: '',
      message: '无法继续办理登机手续',
    },
    du_NL: {
      title: '',
      message: 'Kan het inchecken niet voortzetten',
    },
    pt_PT: {
      title: '',
      message: 'Não é possível continuar o check-in',
    },
    fr_FR: {
      title: '',
      message: "Je ne peux pas continuer l'enregistrement",
    },
  },
  {
    code: '202003',
    en_US: {
      title: '',
      message: '!PRE-RESERVED SEAT NOT SUCCESSFUL',
    },
    es_MX: {
      title: '',
      message: '!PRE-RESERVED SEAT NOT SUCCESSFUL',
    },
    ja_JP: {
      title: '',
      message: '!PRE-RESERVED SEAT NOT SUCCESSFUL',
    },
    kr_KR: {
      title: '',
      message: '!PRE-RESERVED SEAT NOT SUCCESSFUL',
    },
    zh_CN: {
      title: '',
      message: '!PRE-RESERVED SEAT NOT SUCCESSFUL',
    },
    du_NL: {
      title: '',
      message: '!PRE-RESERVED SEAT NOT SUCCESSFUL',
    },
    pt_PT: {
      title: '',
      message: '!PRE-RESERVED SEAT NOT SUCCESSFUL',
    },
    fr_FR: {
      title: '',
      message: '!PRE-RESERVED SEAT NOT SUCCESSFUL',
    },
  },
  {
    code: '204194',
    en_US: {
      title: '',
      message:
        "You can't drop baggage yet. Please check back later or head to one of our check-in counters at the airport.",
    },
    es_MX: {
      title: '',
      message:
        'Por el momento no puedes documentar tu equipaje en quioscos. Por favor, regresa más tarde o dirígete a mostradores',
    },
    ja_JP: {
      title: '',
      message:
        '現時点では、キオスク（自動チェックインスクリーン）でお荷物はお預かり出来ません。お手数ですが、後程またおいで下さるか、カウンターまでお越しください。',
    },
    kr_KR: {
      title: '',
      message:
        '현재 귀하의 수하물을 무인 탑승권발매대에서 등록할 수 없습니다. 나중에 다시 오시거나 카운터로 가십시오',
    },
    zh_CN: {
      title: '',
      message: '很抱歉，现在暂时不能通过自助机器办理托运行李。请晚一些时候过来或直接到柜台办理！',
    },
    du_NL: {
      title: '',
      message:
        'Op dit moment is het niet mogelijk je bagage te documenteren bij de kiosk. Kom later terug of ga naar een van de incheckbalies.',
    },
    pt_PT: {
      title: '',
      message:
        'No momento, você não pode despachar sua bagagem em totens. Por favor, volte mais tarde ou dirige-se aos balcões.',
    },
    fr_FR: {
      title: '',
      message:
        'Pour le moment vous ne pouvez pas enregistrer vos bagages dans les bornes. Veuilles retourner ultérieurement ou bine vous diriger aux comptoirs.',
    },
  },
  {
    code: '207001',
    en_US: {
      title: '',
      message: 'UNABLE TO CONTACT TIMATIC',
    },
    es_MX: {
      title: '',
      message: 'UNABLE TO CONTACT TIMATIC',
    },
    ja_JP: {
      title: '',
      message: 'UNABLE TO CONTACT TIMATIC',
    },
    kr_KR: {
      title: '',
      message: 'UNABLE TO CONTACT TIMATIC',
    },
    zh_CN: {
      title: '',
      message: 'UNABLE TO CONTACT TIMATIC',
    },
    du_NL: {
      title: '',
      message: 'UNABLE TO CONTACT TIMATIC',
    },
    pt_PT: {
      title: '',
      message: 'UNABLE TO CONTACT TIMATIC',
    },
    fr_FR: {
      title: '',
      message: 'UNABLE TO CONTACT TIMATIC',
    },
  },
  {
    _errorDescription: 'UNACCOMPANIED_MINOR',
    code: 'e1',
    en_US: {
      title: 'Check-in at a counter',
      message:
        'This itinerary has an unacommpanied minor(s). Please check-in at an Aeromexico counter with your authorization form.',
    },
    es_MX: {
      title: 'Hacer Check-in en mostrador',
      message:
        'Este itinerario tiene un menor sin acompañante. Por favor haz tu Check-in en un mostrador con un agente y tu forma de autorización.',
    },
    ja_JP: {
      title: 'チェックインはカウンターへ',
      message:
        'この旅程はご同伴者なしの未成年者のものです。認証フォームをお持ちの上、アエロメヒコ航空のカウンターでチェックインしてください。',
    },
    kr_KR: {
      title: '카운터에서 체크인하십시오',
      message:
        '이 여행 일정에 보호자가 동행하지 않은 미성년자가 있습니다. 승인 양식을 가지고 Aeromexico 카운터에서 체크인하십시오.',
    },
    zh_CN: {
      title: '在柜台办理登机手续',
      message: '本行程计划中有无人陪伴的儿童。请在墨西哥航空公司柜台使用授权表办理。',
    },
    du_NL: {
      title: 'Check in bij een balie',
      message:
        'In dit vluchtplan bevinden zich een of meer minderjarige passagiers zonder begeleiding. U kunt bij een balie van Aeroméxico inchecken met uw autorisatieformulier.',
    },
    pt_PT: {
      title: 'Faça seu heck-in em um balcão de atendimento',
      message:
        'Neste itinerário, há menor(es) desacompanhado(s). Por favor faça seu check-in no balcão de atendimento da Aeroméxico com seu formulário de autorização.',
    },
    fr_FR: {
      title: "Enregistrez-vous auprès d'un comptoir de service",
      message:
        "Un mineur non-accompagné est présent sur cet itinéraire. Veuillez vous enregistrer auprès d'un comptoir Aeromexico en présentant votre formulaire d'autorisation.",
    },
  },
  {
    _errorDescription: 'SCAN_PASSPORT_ERROR',
    code: 'e2',
    en_US: {
      title: 'Unable to read passport',
      message: 'Error reading your passport information.',
    },
    es_MX: {
      title: 'Error de lectura',
      message: 'Lo sentimos, no pudimos leer la información de tu pasaporte',
    },
    ja_JP: {
      title: '旅券が読み取れません',
      message: '旅券情報の読み込みエラー',
    },
    kr_KR: {
      title: '여권을 판독할 수 없습니다',
      message: '여권 정보를 판독하는 중 오류가 발생했습니다.',
    },
    zh_CN: {
      title: '无法读取护照',
      message: '读取护照信息时出错。',
    },
    du_NL: {
      title: 'Uw paspoort kan niet gelezen worden',
      message: 'Bij het lezen van de gegevens van uw paspoort is iets misgegaan.',
    },
    pt_PT: {
      title: 'Não foi possível fazer a leitura de seu passporte',
      message: 'Erro de leitura das informações de seu passaporte.',
    },
    fr_FR: {
      title: 'Lecture du passeport impossible',
      message: 'Une erreur est survnue lors de la lecture des informations de votre passeport.',
    },
  },
  {
    _errorDescription: 'GENERIC_ERROR',
    code: 'e3',
    en_US: {
      title: "We're Sorry!",
      message:
        'Something went wrong and we are not able to checkin you at the kiosk. Please check-in at an Aeromexico counter with your authorization form.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message:
        'Ocurrió un error y no podemos hacer tu Check-in en mostrador electrónico. Por favor haz tu Check-in en un mostrador con un agente y tu forma de autorización.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message:
        '何かがうまくいきません、キオスクでのチェックインは不可能です。認証フォームをお持ちの上、アエロメヒコのカウンターでチェックインしてください。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message:
        '오류가 발생하여 발권기에서 체크인할 수 없습니다. 승인 양식을 가지고 Aeromexico 카운터에서 체크인하십시오.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '发生错误，我们无法在售票处为您办理登机手续。请在墨西哥航空公司柜台使用授权表办理。',
    },
    du_NL: {
      title: 'Nous sommes désolés !',
      message:
        'Er is iets misgegaan. U kunt bij de kiosk niet inchecken. U kunt bij een balie van Aeroméxico inchecken met uw autorisatieformulier.',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message:
        'Aconteceu algum problema, e não é possível fazer seu check-in no terminal de autoatendimento. Por favor faça seu check-in no balcão de atendimento da Aeroméxico com seu formulário de autorização.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        "Une erreur est survenue et nous ne pouvons pas procéder à votre enregistrement auprès de ce kiosque. Veuillez vous enregistrer auprès d'un comptoir Aeromexico en présentant votre formulaire d'autorisation.",
    },
  },
  {
    _errorDescription: 'STATIC_PROFILE_UPDATE',
    code: 'e4',
    en_US: {
      title: "We're Sorry!",
      message: 'Static profiles can not be edited',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'Perfiles estáticos no pueden ser editados',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: 'プロファイルの編集がで不可能.',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '고정 프로필을 편집할 수 없습니다.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '无法编辑静态配置文件.',
    },
    du_NL: {
      title: 'Nous sommes désolés !',
      message: 'Statische profielen kunnen niet bewerkt worden',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: 'Não é possível editar perfis estáticos.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: 'Les profils statiques des utilisateurs ne peuvent être modifiés.',
    },
  },
  {
    _errorDescription: 'ALL_SEATS_SELECTED',
    code: 'e5',
    en_US: {
      title: "We're Sorry!",
      message: 'No seat map available now. Please try to check in.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'No está disponible la selección de asientos. Por favor, haga su check in.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: 'ただいまシードマップがご利用いただけません。チェックインしてみてください',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '좌석 맵을 현재 이용할 수 없습니다. 체크인을 시도하십시오.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '目前座位图不可用。请尝试进行登机手续.',
    },
    du_NL: {
      title: 'Nous sommes désolés !',
      message: 'Stoelindeling momenteel niet beschikbaar. Probeer in te checken.',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message:
        'No momento, o mapa de assentos não está disponível. Por favor, tente fazer o check-in.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        "Aucun plan de cabine n'est disponible pour l'instant. Veuillez essayer de vous enregistrer.",
    },
  },
  {
    _errorDescription: 'AGENT_SCAN_FAILED',
    code: 'e6',
    en_US: {
      title: "We're Sorry!",
      message: 'Invalid authorization code.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'Invalid authorization code',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: '無効な認証コード',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '유효하지 않은 승인 코드',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '无效的授权代码',
    },
    du_NL: {
      title: 'Nous sommes désolés !',
      message: 'Onjuiste autorisatiecode.',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: 'Código de autorização inválido.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: "Code d'autorisation non valide",
    },
  },
  {
    _errorDescription: 'FREQUENT_FLIER_ERROR',
    code: 'e7',
    en_US: {
      title: "We're Sorry!",
      message: 'Error adding frequent flyer number',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'Error agregando el número de viajero frecuente.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: '常連客番号を追加エラー',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '상용 고객 우대 번호를 추가하는 중 오류 발생',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '添加飞行常客人数时出错',
    },
    du_NL: {
      title: 'Nous sommes désolés !',
      message: 'Fout bij invoeren frequent flyer nummer',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: 'Erro ao adicionar número do programa de fidelidade',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: 'Une erreur est survenue lors de la saisie du numéro FF de passager régulier',
    },
  },
  {
    _errorDescription: 'PAYMENT_ERROR_RETRY',
    code: 'e8',
    en_US: {
      title: "We're Sorry!",
      message:
        'Something went wrong and we weren’t able to process your payment. Please try again.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'Ocurrió un error y no podemos procesar tu pago. Por favor inténtalo de nuevo.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message:
        '何かがうまくいきません、お客様のお支払いを処理することができませんでした。再度お試しください',
    },
    kr_KR: {
      title: '죄송합니다!',
      message:
        'Something went wrong and we weren’t able to process your payment. Please try again.',
    },
    zh_CN: {
      title: 'Nous sommes désolés !',
      message: '发生错误，我们无法处理您的支付。请重试。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message:
        'Er is iets misgegaan. Uw betaalopdracht kan niet verwerkt worden. Probeer het opnieuw.',
    },
    pt_PT: {
      title: 'Sentimos Muito!',
      message:
        'Aconteceu algum problema, e não é possível processar seu pagamento. Tente novamente, por favor.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        'Une erreur est survenue et nous ne pouvons pas procéder à votre enregistrement auprès de ce kiosque. Veuillez réessayer.',
    },
  },
  {
    _errorDescription: '',
    code: 'e9',
    en_US: {
      title: "We're Sorry!",
      message:
        'Something went wrong and we are not able to process your payment at the kiosk. Please check-in at an Aeromexico counter with your authorization form.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message:
        'Algo ocurrió y no podemos procesar tu pago en el mostrador automático. Por favor haz tu Check-in en un mostrador con un agente y tu forma de autorización.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message:
        '何かがうまくいきません、このキオスクでお客様のお支払いを処理することができません。認証フォームをお持ちの上、アエロメヒコ航空のカウンターでチェックインしてください。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message:
        '오류가 발생하여 발권기에서 결제를 처리할 수 없습니다. 승인 양식을 가지고 Aeromexico 카운터에서 체크인하십시오.',
    },
    zh_CN: {
      title: 'Nous sommes désolés !',
      message: '发生错误，我们无法在售票处处理您的支付。请在墨西哥航空公司柜台使用授权表办理。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message:
        'Er is iets misgegaan. Uw betaalopdracht kan niet verwerkt worden. U kunt bij een balie van Aeroméxico inchecken met uw autorisatieformulier.',
    },
    pt_PT: {
      title: 'Sentimos Muito!',
      message:
        'Aconteceu algum problema, e não é possível processar seu pagamento no terminal de autoatendimento. Por favor faça seu check-in no balcão de atendimento da Aeroméxico com seu formulário de autorização.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        "Une erreur est survenue et nous ne pouvons pas procéder au paiement auprès de ce kiosque. Veuillez vous enregistrer auprès d'un comptoir Aeromexico en présentant votre formulaire d'autorisation.",
    },
  },
  {
    _errorDescription: 'UNACCOMPANIED_MINOR',
    code: 'e10',
    en_US: {
      title: 'Check-in at a counter',
      message:
        'This itinerary has an unacommpanied minor(s). Please check-in at an Aeromexico counter with your authorization form.',
    },
    es_MX: {
      title: 'Hacer Check-in en mostrador',
      message:
        'Este itinerario tiene un menor sin acompañante. Por favor haz tu Check-in en un mostrador con un agente y tu forma de autorización.',
    },
    ja_JP: {
      title: 'チェックインはカウンターへ',
      message:
        'この旅程はご同伴者なしの未成年者のものです。認証フォームをお持ちの上、アエロメヒコ航空のカウンターでチェックインしてください。',
    },
    kr_KR: {
      title: '카운터에서 체크인하십시오',
      message:
        '이 여행 일정에 보호자가 동행하지 않은 미성년자가 있습니다. 승인 양식을 가지고 Aeromexico 카운터에서 체크인하십시오.',
    },
    zh_CN: {
      title: '在柜台办理登机手续',
      message: '本行程计划中有无人陪伴的儿童。请在墨西哥航空公司柜台使用授权表办理。',
    },
    du_NL: {
      title: 'Check in bij een balie',
      message:
        'In dit vluchtplan bevinden zich een of meer minderjarige passagiers zonder begeleiding. U kunt bij een balie van Aeroméxico inchecken met uw autorisatieformulier.',
    },
    pt_PT: {
      title: 'Faça seu heck-in em um balcão de atendimento',
      message:
        'Neste itinerário, há menor(es) desacompanhado(s). Por favor faça seu check-in no balcão de atendimento da Aeroméxico com seu formulário de autorização.',
    },
    fr_FR: {
      title: "Enregistrez-vous auprès d'un comptoir de service",
      message:
        "Un mineur non-accompagné est présent sur cet itinéraire. Veuillez vous enregistrer auprès d'un comptoir Aeromexico en présentant votre formulaire d'autorisation.",
    },
  },
  {
    _errorDescription: 'CREDIT_CARD_READ_ERROR',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message: 'Error reading your credit card information. Would you like to retry?',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message:
        'Hubo un error al leer tu información de tarjeta de crédito. ¿Quieres volver a intentarlo?',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: 'クレジットカード読み取りアラー,再度お試ししますか？',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '신용 카드 정보를 판독하는 중 오류가 발생했습니다. 다시 시도해 주시겠습니까?',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '信用卡信息读取失败。要重试吗？',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message:
        'Bij het lezen van de gegevens van uw creditcard is iets misgegaan. Wilt u het opnieuw proberen?',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message:
        'Erro de leitura das informações de seu cartão de crédito. Gostaria de tentar novamente?',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        'Une erreur est survnue lors de la lecture des informations de votre carte de crédit. Veuillez réessayer.',
    },
  },
  {
    _errorDescription: 'CREDIT_CARD_DECLINED',
    code: '',
    en_US: {
      title: 'Payment declined',
      message:
        'Please try again or change your trip options to continue without any additional extras.',
    },
    es_MX: {
      title: 'Pago declinado',
      message:
        'Por favor vuelve a intentarlo o edita tu cuenta para no tener productos adicionales.',
    },
    ja_JP: {
      title: '決済が拒否されました',
      message: '再度お試しください、もしくは追加料金なしのオプションに変更してみてください。',
    },
    kr_KR: {
      title: '결제가 거부되었습니다',
      message: '다시 시도하거나 여행 옵션을 변경하여 추가적인 비용 없이 계속 진행하십시오.',
    },
    zh_CN: {
      title: '支付被拒绝',
      message: '请重试或更改您的旅程选项，以便在没有额外附加的情况下继续。',
    },
    du_NL: {
      title: 'Betaling geweigerd',
      message:
        "Probeer opnieuw of wijzig uw reisopties door verder te gaan zonder verdere extra's toe te voegen.",
    },
    pt_PT: {
      title: 'Pagamento recusado',
      message:
        'Por favor, tente novamente ou altere suas opções de viagem para continuar sem a incidência de custos adicionais.',
    },
    fr_FR: {
      title: 'Paiement refusé',
      message:
        'Veuillez réessayer ou bien changez les options de voyage afin de continuer sans supplément additionnel.',
    },
  },
  {
    _errorDescription: 'PASSPORT_SCAN_ERROR',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message: 'Error reading your passport information.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'Lo sentimos, no pudimos leer la información de tu pasaporte',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: '旅券情報の読み込みエラー',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '여권 정보를 판독하는 중 오류가 발생했습니다.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '读取护照信息时出错。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message: 'Bij het lezen van de gegevens van uw paspoort is iets misgegaan.',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: 'Erro de leitura das informações de seu passaporte.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: 'Une erreur est survnue lors de la lecture des informations de votre passeport.',
    },
  },
  {
    _errorDescription: 'RESERVATION_NOT_FOUND',
    code: '',
    en_US: {
      title: 'Reservation not found',
      message:
        'We couldn’t locate your itinerary. Check if the information you entered is correct and try again.',
    },
    es_MX: {
      title: 'Reservación no encontrada',
      message:
        'No pudimos encontrar tu itinerario. Revisa si la información que ingresaste es correcta e inténtalo de nuevo.',
    },
    ja_JP: {
      title: 'ご予約が見つかりません',
      message: 'ご旅程が見つかりませんでした。入力した情報が正しいか確認し、再びお試しください。',
    },
    kr_KR: {
      title: '예약 결과를 찾을 수 없음',
      message:
        '귀하의 여행 일정을 찾을 수 없습니다. 입력한 정보가 올바른지 확인하고 다시 시도하십시오.',
    },
    zh_CN: {
      title: '找不到预约',
      message: '找不到您的行程计划。请检查您输入的信息是否正确，然后重试。',
    },
    du_NL: {
      title: 'Reservering niet gevonden',
      message:
        'Uw reisroute is niet gevonden. Controleer of de door u ingevoerde gegevens correct zijn en probeer opnieuw.',
    },
    pt_PT: {
      title: 'Reserva não encontrada',
      message:
        'Não foi possível localizar seu itinerário. Verifique se as informações inseridas estão corretas e  tente novamente.',
    },
    fr_FR: {
      title: "La réservation n'apparaît pas",
      message:
        "Nous n'avons pas pu répertorier votre itinéraire. Vérifiez l'exactitude des informations saisies et réessayez.",
    },
  },
  {
    _errorDescription: 'TSA_VALIDATION',
    code: '',
    en_US: {
      title: 'Please proceed to airport counter to Check-in',
      message: 'Go to TSA airport counter to Check-in and get your boarding passes',
    },
    es_MX: {
      title:
        'Por favor, preséntate en mostradores para hacer Check-in y obtener tu pase de abordar',
      message: '',
    },
    ja_JP: {
      title: '空港のチェックインカウンターでチェックしてください',
      message: 'TSA空港のチェックインカウンターでチェックインし、搭乗券をお受取りください',
    },
    kr_KR: {
      title: '공항 체크인 카운터에서 체크인하십시요',
      message: 'TSA 공항 카운터에서 체크인하시고 보딩패스를 받으십시요',
    },
    zh_CN: {
      title: '请前往机场前台办理登机手续',
      message: '请前往TSA机场前台办理登机手续并领取登机牌',
    },
    du_NL: {
      title: 'Ga naar de balie om in te checken',
      message: 'Ga naar de TSA-balie om in te checken en haal uw boardingpass',
    },
    pt_PT: {
      title: 'Dirija-se ao balcão de atendimento para fazer seu check-in',
      message:
        'Dirija-se ao  balcão de atendimento da TSA para fazer seu check-in e imprimir seus cartões de embarque',
    },
    fr_FR: {
      title: "Adressez-vous à un comptoir d'enregistrement",
      message:
        "Adressez-vous à un comptoir de l'Administration pour la sécurité des transports afin de procéder à votre enregistrement pour obtenir vos cartes d’embarquement",
    },
  },
  {
    _errorDescription: 'UNABLE_TO_REMOVE_ITEM',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message: 'Unable to remove item from cart.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'No se puede quitar el elemento del carrito.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: 'カートからアイテムを除くことができません。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '카트에서 품목을 제거할 수 없습니다.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '无法从购物车中移除物品。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message: 'Item kan niet uit winkelwagentje verwijderd worden.',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: 'Não foi possível remover item do carrinho de compras.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: "Impossible d'enlever de votre panier les éléments sélectionnés.",
    },
  },
  {
    _errorDescription: 'CREDIT_CARD_HOST_ERROR',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message:
        'Unable to complete the transaction, please try again or change your trip options to continue without any additional extras.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message:
        'No se pudo completar la transacción, inténtalo de nuevo o edita tu cuenta para no tener productos adicionales.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: 'トランザクションが完了できません、追加料金なしのオプションに変更してみてください。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message:
        '거래를 완료할 수 없습니다. 다시 시도하거나 여행 옵션을 변경하여 추가적인 비용 없이 계속 진행하십시오.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '无法完成交易，请重试或更改您的旅程选项，以便在没有额外附加的情况下继续。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message:
        "Transactie kan niet afgerond worden. Probeer opnieuw of wijzig uw reisopties door verder te gaan zonder verdere extra's toe te voegen.",
    },
    pt_PT: {
      title: 'Sentimos Muito!',
      message:
        'Não foi possível completar a transação. Por favor, tente novamente ou altere suas opções de viagem para continuar sem a incidência de custos adicionais.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        'Impossible de finaliser la transaction. Veuillez réessayer ou bien changez les options de voyage afin de continuer sans supplément additionnel.',
    },
  },
  {
    _errorDescription: 'CHECKIN_ERROR',
    code: '201009',
    en_US: {
      title: "We're Sorry!",
      message: 'Your check-in could not be completed. Please proceed to a check-in counter.',
    },
    es_MX: {
      title: 'Completa tu Check-in en el mostrador',
      message:
        'Tu información ha sido guardada. Por favor, acude al mostrador para completar tu Check-in.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message:
        'お客様のチェックインが完了できませんでした。チェックインカウンターへお越しください。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '체크인을 완료할 수 없습니다. 카운터에서 체크인을 계속 진행하십시오.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '无法完成您的登机手续。请前往登机手续柜台办理。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message:
        'Transactie kan niet afgerond worden. Begeef u naar de balie om het inchecken af te ronden.',
    },
    pt_PT: {
      title: 'Sentimos Muito!',
      message:
        'Não foi possível completar a transação. Por favor, dirija-se até o balcão de atendimento para finalizar o check-in.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        ' Impossible de finaliser la transaction. Veuillez vous rendre au comptoir afin de finaliser votre enregistrement.',
    },
  },
  {
    _errorDescription: 'CHECKIN_ERROR',
    code: '204018',
    en_US: {
      title: "We're Sorry!",
      message: 'Your check-in could not be completed. Please proceed to a check-in counter.',
    },
    es_MX: {
      title: 'Completa tu Check-in en el mostrador',
      message:
        'Tu información ha sido guardada. Por favor, acude al mostrador para completar tu Check-in.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message:
        'お客様のチェックインが完了できませんでした。チェックインカウンターへお越しください。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '체크인을 완료할 수 없습니다. 카운터에서 체크인을 계속 진행하십시오.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '无法完成您的登机手续。请前往登机手续柜台办理。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message:
        'Transactie kan niet afgerond worden. Begeef u naar de balie om het inchecken af te ronden.',
    },
    pt_PT: {
      title: 'Sentimos Muito!',
      message:
        'Não foi possível completar a transação. Por favor, dirija-se até o balcão de atendimento para finalizar o check-in.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        ' Impossible de finaliser la transaction. Veuillez vous rendre au comptoir afin de finaliser votre enregistrement.',
    },
  },
  {
    _errorDescription: 'FAILED_TO_RESERVE_PREMIERE_UPGRADE',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message: 'Failed to reserve the premiere upgrade',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'El ascenso a Clase Premier no se pudo realizar.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: 'プレミアクラスへのアップグレード予約に失敗',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '프리미에르 업그레이드 예약에 실패했습니다.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '头等舱升级预约失败',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message: 'Premiere upgrade is niet geboekt',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: 'Erro na reserva de upgrade para Clase Premier',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: 'Échec de la réservation de surclassement.',
    },
  },
  {
    _errorDescription: 'REPRINT_BOARDING_PASSES_ERROR',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message:
        'The system can not reprint your boarding pass(es). Please proceed to a counter for help',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message:
        'El sistema no puede volver a imprimir su pase de abordar. Por favor pasa a un mostrador para recibir ayuda.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message:
        'このシステムでお客様の搭乗券の印刷することができません。チェックインカウンターへお越しください。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message:
        '시스템이 탑승권을 재인쇄할 수 없습니다. 지원을 받으려면 당사 서비스 카운터에 문의하시기 바랍니다.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '系统无法重新打印您的登机牌。请前往柜台寻求帮助',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message:
        'Het systeem kan uw boardingpas(sen) niet opnieuw afdrukken. Ga naar een balie voor hulp',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message:
        ' Não é possível reimprimir seu(s) cartão(ões) de embarque. Por favor, dirija-se ao balcão de atendimento para obter ajuda',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        "Impossible pour le système de réimprimer votre/vos carte(s) d'embarquement. Veuillez solliciter de l'aide auprès de l'un de nos comptoirs",
    },
  },
  {
    _errorDescription: 'PROFILE_UPDATE',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message: 'Failed to update profile',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'No se pudo actualizar el perfil',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: 'プロファイルのアップデーターに失敗',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '프로필 업데이트에 실패했습니다.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '未能更新配置文件',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message: 'Update profiel mslukt',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: 'Erro ao atualizar o perfil',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: 'La miise à jour du profil a échoué',
    },
  },
  {
    _errorDescription: 'PINPAD_INIT_FAIL',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message: 'Failed to initialize the terminal, please try again.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'Error al iniciar la pin-pad, por favor intenta de nuevo.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: '端末の初期化に失敗、再びお試しください。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '단말기 초기화에 실패했습니다. 다시 시도하십시오.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '未能初始化终端，请重试。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message: 'Pinpad kan niet geïnitialiseerd worden.',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: 'Erro ao iniciar o terminal. Por favor, tente novamente.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: "Echec d'initialisation du clavier",
    },
  },
  {
    _errorDescription: 'EMAIL_ERROR',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message: 'Failed to send email',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'No se pudo mandar el correo.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: 'メールの送信ができませんでした',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '이메일 전송 실패',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '无法发送电子邮件',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message: 'E-mail is niet verzonden',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: 'Erro ao enviar e-mail',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: "Échec de l'envoi de courriel",
    },
  },
  {
    _errorDescription: 'PINPAD_NOT_READY_ERROR',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message:
        'Terminal not ready, remove any credit cards that might still be in the terminal and try again.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message:
        'La terminal no está lista, retire la tarjeta de crédito de la terminal e intente de nuevo.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: '端末がまだ準備できていません、カードを外し、再試行してください。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message:
        '단말기가 준비되지 않았습니다. 단말기에 삽입되어 있는 신용 카드를 빼내 다시 시도하십시오.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '终端没有准备好，请取出仍在终端中的信用卡并重试。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message:
        'Terminal niet gereed. Verwijder creditcards die nog in de terminal liggen en probeer opnieuw.',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message:
        'O terminal não está pronto. Remova os cartões que ainda estejam no terminal e tente novamente.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        "Le terminal n'est pas prêt. Veuillez retirer votre carte insérée dans le terminal et réssayez.",
    },
  },
  {
    _errorDescription: 'MANUALLY_ENTERED_CARD_ERROR',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message: 'Credit card information cannot be entered manually.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'La información de la tarjeta de crédito no puede ingresarse manualmente.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: '手動でクレジットカードの情報を入力できません。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '신용 카드 정보를 수동으로 입력할 수 없습니다.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '信用卡信息无法手动输入。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message: 'Creditcard gegevens kunnen niet handmatig ingevoerd worden',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: 'Não é possível inserir manualmente as informações do cartão de crédito.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: 'Les données de la carte de crédit ne peuvent être saisies manuellement.',
    },
  },
  {
    _errorDescription: 'OVERWEIGHT_BAG_CHECKIN_ERROR',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message:
        "Your bag is overweight.  Would you like to try again? If 'No', please proceed to the counter.",
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message:
        'Lo sentimos. Tu maleta tiene sobrepeso. Por favor quítale peso y vuelve a intentarlo.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message:
        'お荷物が重量オーバーです。再試行してみますか。いいえの場合は、カウンターへお越しください。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message:
        "백이 중량을 초과했습니다.  다시 시도해 주시겠습니까? '아니요'를 선택한 경우, 카운터에 문의하십시오.",
    },
    zh_CN: {
      title: '很抱歉！',
      message: '您的行李超重。要重试吗？如果选择“否”，请前往柜台。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message:
        "Uw koffer heeft overgewicht.  Wilt u het opnieuw proberen? Indien 'Nee', ga naar de balie.",
    },
    pt_PT: {
      title: 'Lamentamos!',
      message:
        "Sua bagagem excede o limite de peso.  Deseja tentar novamente? Se a resposta for 'Não', por favor dirija-se até o balcão de atendimento.",
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        "Votre bagage présente un excédent de poids.  Souhaitez-vous essayer de nouveau ? Sinon, veuillez vous rendre au comptoir d'enregistrement.",
    },
  },
  {
    _errorDescription: 'PAYMENT_NOT_SUPPORTED',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message: 'There is a balance due, please go to the counter',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'Hay un saldo adeudado, por favor vaya al mostrador',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: '未払いなので、カウンターへお越しください',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '잔액이 부족합니다. 카운터에 문의하십시오.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '存在尚欠余额，请前往柜台',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message: 'Er is een debetsaldo, ga naar de balie',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message: 'Há um saldo devedor, por favor dirija-se ao balcão de atendimento',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message: "Un solde dû nous apparaît. Veuillez solliciter de l'aide auprès d'un comptoir",
    },
  },
  {
    _errorDescription: 'CART_UPDATE_FAILED',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message: 'The system could not process your request. Please proceed to a counter for help',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: ' El sistema no pudo procesar su solicitud. Acude a mostrador para obtener ayuda.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message:
        'このシステムではお客様の要求を処理することができません。カウンターへ助けをお求めください。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message:
        '시스템이 귀하의 요청을 처리할 수 없습니다. 지원을 받으려면 당사 서비스 카운터에 문의하시기 바랍니다.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '系统无法处理您的请求。请前往柜台寻求帮助',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message: 'Het systeem kan uw verzoek niet verwerken. Ga naar een balie voor hulp',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message:
        'Não foi possível processar sua solicitação através do sistema. Por favor, dirija-se ao balcão de atendimento para obter ajuda',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        "Le système n'a pu traiter votre demande. Veuillez solliciter de l'aide auprès de l'un de nos comptoirs",
    },
  },
  {
    _errorDescription: 'BAG_TAG_ERROR',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message: 'Unable to print bag tags. Please proceed to the counter to drop your bag(s).',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message:
        'Error al imprimir las etiquetas. Por favor, pase al mostrador a documentar su equipaje',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: 'バッグタグの印刷できません。カウンターで受託手続きをしてください。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '백 태그를 인쇄할 수 없습니다. 백을 드롭하려면 카운터로 이동하십시오.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '无法打印行李标签。请在前台办理托运手续。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message:
        'Bagagelabels kunnen niet afgedrukt worden. Ga naar de balie om uw bagage af te geven.',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message:
        'Não é possível imprimir as etiquetas de bagagem. Por favor, dirija-se ao balcão de atendimento para despachar sua bagagem.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        "Impossible d'imprimer les étiquettes des bagages. Veuillez vous rendre au comptoir d'enregistrement pour enregistrer et déposer vos bagages.",
    },
  },
  {
    _errorDescription: 'OVER_BOOKING_UPDATE_ERROR',
    code: '',
    en_US: {
      title: "We're Sorry!",
      message: 'Unable to update overbooking compensation, please try again.',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message: 'No pudimos procesar tu compensación. Por favor intenta de nuevo.',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message: 'オーバーブッキング補償を更新することができませんでした、もう一度お試しください。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message: '오버부킹 보상 관련, 업데이트가 불가능합니다. 다시 시도해 주세요.',
    },
    zh_CN: {
      title: '很抱歉！',
      message: '无法更新超额订票补偿，请再试一次。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message: 'Update vergoeding overboeking mislukt. Probeer opnieuw.',
    },
    pt_PT: {
      title: 'Lamentamos!',
      message:
        'Não foi possível atualizar a compensação por overbooking. Por favor, tente novamente.',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        'Impossible de mettre à jour la compensation pour surréservation. Veuillez réessayer.',
    },
  },
  {
    _errorDescription: '',
    code: '204129',
    en_US: {
      title: 'Input Error!',
      message: 'INVALID EXP DATE , UNKNOWN CODE.',
    },
    es_MX: {
      title: 'Input Error!',
      message: 'INVALID EXP DATE , UNKNOWN CODE.',
    },
    ja_JP: {
      title: 'Input Error!',
      message: 'INVALID EXP DATE , UNKNOWN CODE.',
    },
    kr_KR: {
      title: 'Input Error!',
      message: 'INVALID EXP DATE , UNKNOWN CODE.',
    },
    zh_CN: {
      title: 'Input Error!',
      message: 'INVALID EXP DATE , UNKNOWN CODE.',
    },
    du_NL: {
      title: 'Input Error!',
      message: 'INVALID EXP DATE , UNKNOWN CODE.',
    },
    pt_PT: {
      title: 'Input Error!',
      message: 'INVALID EXP DATE , UNKNOWN CODE.',
    },
    fr_FR: {
      title: 'Input Error!',
      message: 'INVALID EXP DATE , UNKNOWN CODE.',
    },
  },
  {
    _errorDescription: '',
    code: '202001',
    en_US: {
      title: 'Input Error!',
      message: 'Visa issuing date is not valid.',
    },
    es_MX: {
      title: 'Input Error!',
      message: 'Visa issuing date is not valid.',
    },
    ja_JP: {
      title: 'Input Error!',
      message: 'Visa issuing date is not valid.',
    },
    kr_KR: {
      title: 'Input Error!',
      message: 'Visa issuing date is not valid.',
    },
    zh_CN: {
      title: 'Input Error!',
      message: 'Visa issuing date is not valid.',
    },
    du_NL: {
      title: 'Input Error!',
      message: 'Visa issuing date is not valid.',
    },
    pt_PT: {
      title: 'Input Error!',
      message: 'Visa issuing date is not valid.',
    },
    fr_FR: {
      title: 'Input Error!',
      message: 'Visa issuing date is not valid.',
    },
  },
  {
    _errorDescription: 'FARELOCK_ERROR',
    code: '2014412',
    en_US: {
      title: 'Your reservation is on hold',
      message:
        'To continue with your journey, please proceed to the check‑in counter and complete the payment process.',
    },
    es_MX: {
      title: 'Tu reserva está en espera',
      message:
        'Para continuar con tu viaje, te invitamos a pasar al mostrador y completar el proceso de pago.',
    },
    ja_JP: {
      title: 'ご予約は保留中です。',
      message: '旅を続けるには、カウンターにお越しいただき、お支払い手続きを完了してください。',
    },
    kr_KR: {
      title: '귀하의 예약은 보류 중입니다.',
      message: '여행을 계속하려면 카운터로 가셔서 결제 절차를 완료해 주세요.',
    },
    zh_CN: {
      title: '您的预订处于待定状态。',
      message: '要继续您的旅程，请前往柜台并完成支付流程。',
    },
    du_NL: {
      title: 'Uw reservering staat in de wacht.',
      message:
        'Om uw reis voort te zetten, nodigen wij u uit naar de balie te gaan en het betalingsproces te voltooien.',
    },
    pt_PT: {
      title: 'Sua reserva está em espera.',
      message:
        'Para continuar sua viagem, convidamos você a ir ao balcão e concluir o processo de pagamento.',
    },
    fr_FR: {
      title: 'Votre réservation est en attente.',
      message:
        'Pour poursuivre votre voyage, nous vous invitons à vous rendre au comptoir et à finaliser le paiement.',
    },
  },
  {
    _errorDescription: 'CHECKIN_ERROR',
    code: '204020',
    en_US: {
      title: "We're Sorry!",
      message:
        'Dear Client,\nOur priority is to provide you with the best service; your flight is presenting high demand and an additional process is needed to conclude your seat assignment; please proceed to our counters',
    },
    es_MX: {
      title: '¡Lo sentimos!',
      message:
        'Estimado cliente,\nNuestra prioridad es brindarte el mejor servicio; tu vuelo presenta alta demanda y es necesario un proceso adicional para concluir con la asignación de tus asientos, por favor pasa a nuestros mostradores',
    },
    ja_JP: {
      title: '申し訳ございません。',
      message:
        'お客さま                              私たちは、お客様に最高のサービスを提供することを第一に考えています。お客様のフライトが混雑しており、座席指定に追加手続きが必要です。カウンターまでお越しください。',
    },
    kr_KR: {
      title: '죄송합니다!',
      message:
        '승객여러분, 저희는 여러분께 최상의 서비스를 제공하고자 합니다; 귀하가 이용하는 항공편이 만석으로 귀하의 좌석을 지정하기 위해 추가 절차가 필요합니다. 저희 카운터로  오시기 바랍니다.',
    },
    zh_CN: {
      title: '很抱歉！',
      message:
        '各位乘客：\n乘客至上是我们的服务宗旨，鉴于本次航班座位的需求量很大，请到柜台再次办理座位分配。',
    },
    du_NL: {
      title: 'Het spijt ons!',
      message:
        'Beste klant,\nHet is onze prioriteit u een zo goed mogelijke service te bieden; er is veel vraag naar uw vlucht en we moeten een extra procedure uitvoeren om uw stoelen toe te wijzen. We verzoeken u naar onze balies te gaan.',
    },
    pt_PT: {
      title: 'Sentimos Muito!',
      message:
        'Estimado cliente,\nA nossa prioridade é prestar-lhe o melhor serviço. Seu voo está em alta demanda e é necessário um processo adicional para concluir com a atribuição de seus assentos. Dirija-se aos nossos balcões',
    },
    fr_FR: {
      title: 'Nous sommes désolés !',
      message:
        "Cher client,\nNotre priorité est de vous offrir le meilleur service. Votre vol est très demandé et une démarche supplémentaire est nécessaire pour finaliser l'attribution de vos sièges. Merci de vous présenter à nos guichets",
    },
  },
  {
    _errorDescription: 'Bag tag feature disabled',
    code: 'BAGTAG_DISABLED',
    en_US: {
      title: 'Service Not Available',
      message:
        'Baggage weighing is not available at this kiosk. Please proceed to the counter for assistance.',
    },
    es_MX: {
      title: 'Servicio No Disponible',
      message:
        'El pesaje de equipaje no está disponible en este kiosco. Por favor, diríjase al mostrador para recibir asistencia.',
    },
    ja_JP: {
      title: 'サービス利用不可',
      message:
        'このキオスクでは手荷物の計量は利用できません。カウンターでサポートを受けてください。',
    },
    kr_KR: {
      title: '서비스 이용 불가',
      message:
        '이 키오스크에서는 수하물 계량을 사용할 수 없습니다. 카운터에서 도움을 받으시기 바랍니다.',
    },
    zh_CN: {
      title: '服务不可用',
      message: '此自助服务终端不提供行李称重服务。请前往柜台寻求帮助。',
    },
    du_NL: {
      title: 'Service niet beschikbaar',
      message: 'Bagage weging is niet beschikbaar bij deze kiosk. Ga naar de balie voor hulp.',
    },
    pt_PT: {
      title: 'Serviço Indisponível',
      message:
        'A pesagem de bagagem não está disponível neste quiosque. Por favor, dirija-se ao balcão para assistência.',
    },
    fr_FR: {
      title: 'Service non disponible',
      message:
        "La pesée des bagages n'est pas disponible sur ce kiosque. Veuillez vous rendre au comptoir pour obtenir de l'aide.",
    },
  },
  {
    _errorDescription: 'Scale feature disabled',
    code: 'SCALE_DISABLED',
    en_US: {
      title: 'Service Not Available',
      message:
        'The scale is not available at this kiosk. Please proceed to the counter for assistance.',
    },
    es_MX: {
      title: 'Servicio No Disponible',
      message:
        'La báscula no está disponible en este kiosco. Por favor, diríjase al mostrador para recibir asistencia.',
    },
    ja_JP: {
      title: 'サービス利用不可',
      message: 'このキオスクではスケールは利用できません。カウンターでサポートを受けてください。',
    },
    kr_KR: {
      title: '서비스 이용 불가',
      message: '이 키오스크에서는 저울을 사용할 수 없습니다. 카운터에서 도움을 받으시기 바랍니다.',
    },
    zh_CN: {
      title: '服务不可用',
      message: '此自助服务终端不提供称重服务。请前往柜台寻求帮助。',
    },
    du_NL: {
      title: 'Service niet beschikbaar',
      message: 'De weegschaal is niet beschikbaar bij deze kiosk. Ga naar de balie voor hulp.',
    },
    pt_PT: {
      title: 'Serviço Indisponível',
      message:
        'A balança não está disponível neste quiosque. Por favor, dirija-se ao balcão para assistência.',
    },
    fr_FR: {
      title: 'Service non disponible',
      message:
        "La balance n'est pas disponible sur ce kiosque. Veuillez vous rendre au comptoir pour obtenir de l'aide.",
    },
  },
  {
    _errorDescription: 'Payment feature disabled',
    code: 'PAYMENT_DISABLED',
    en_US: {
      title: 'Service Not Available',
      message:
        'Payment is not available at this kiosk. Please proceed to the counter for assistance.',
    },
    es_MX: {
      title: 'Servicio No Disponible',
      message:
        'El pago no está disponible en este kiosco. Por favor, diríjase al mostrador para recibir asistencia.',
    },
    ja_JP: {
      title: 'サービス利用不可',
      message: 'このキオスクでは支払いは利用できません。カウンターでサポートを受けてください。',
    },
    kr_KR: {
      title: '서비스 이용 불가',
      message: '이 키오스크에서는 결제를 사용할 수 없습니다. 카운터에서 도움을 받으시기 바랍니다.',
    },
    zh_CN: {
      title: '服务不可用',
      message: '此自助服务终端不提供支付服务。请前往柜台寻求帮助。',
    },
    du_NL: {
      title: 'Service niet beschikbaar',
      message: 'Betaling is niet beschikbaar bij deze kiosk. Ga naar de balie voor hulp.',
    },
    pt_PT: {
      title: 'Serviço Indisponível',
      message:
        'O pagamento não está disponível neste quiosque. Por favor, dirija-se ao balcão para assistência.',
    },
    fr_FR: {
      title: 'Service non disponible',
      message:
        "Le paiement n'est pas disponible sur ce kiosque. Veuillez vous rendre au comptoir pour obtenir de l'aide.",
    },
  },
  {
    _errorDescription: 'Seat map feature disabled',
    code: 'SEATMAP_DISABLED',
    en_US: {
      title: 'Service Not Available',
      message:
        'Seat selection is not available at this kiosk. Please proceed to the counter for assistance.',
    },
    es_MX: {
      title: 'Servicio No Disponible',
      message:
        'La selección de asientos no está disponible en este kiosco. Por favor, diríjase al mostrador para recibir asistencia.',
    },
    ja_JP: {
      title: 'サービス利用不可',
      message: 'このキオスクでは座席選択は利用できません。カウンターでサポートを受けてください。',
    },
    kr_KR: {
      title: '서비스 이용 불가',
      message:
        '이 키오스크에서는 좌석 선택을 사용할 수 없습니다. 카운터에서 도움을 받으시기 바랍니다.',
    },
    zh_CN: {
      title: '服务不可用',
      message: '此自助服务终端不提供座位选择服务。请前往柜台寻求帮助。',
    },
    du_NL: {
      title: 'Service niet beschikbaar',
      message: 'Stoelkeuze is niet beschikbaar bij deze kiosk. Ga naar de balie voor hulp.',
    },
    pt_PT: {
      title: 'Serviço Indisponível',
      message:
        'A seleção de assentos não está disponível neste quiosque. Por favor, dirija-se ao balcão para assistência.',
    },
    fr_FR: {
      title: 'Service non disponible',
      message:
        "La sélection de sièges n'est pas disponible sur ce kiosque. Veuillez vous rendre au comptoir pour obtenir de l'aide.",
    },
  },
];

export const messageParamsGeneric: OptsErrorModal = {
  showButton: true,
  buttonCopy: 'errorMsj.continue',
  showIconImage: false,
  urlIconImage: '',
  colorFontButton: 'white-font',
  backGroundButton: 'search-bg',
  sizeModal: 'sd',
  fontWeightTitleError: '600',
  image: '',
  showCancelButton: false,
  cancelButtonText: '',
};

export const messageNoCkn: OptsErrorModal = {
  showButton: true,
  buttonCopy: 'errorMsj.continue',
  showIconImage: false,
  urlIconImage: '',
  colorFontButton: 'white-font',
  backGroundButton: 'search-bg',
  sizeModal: 'sd',
  fontWeightTitleError: '600',
  image: './assets/images/img_no_ckn.svg',
  showCancelButton: false,
  cancelButtonText: '',
};

export const messageNoOverWeight: OptsErrorModal = {
  showClose: false,
  showButton: true,
  buttonCopy: 'srIrops.end',
  showIconImage: false,
  urlIconImage: '',
  colorFontButton: 'white-font',
  backGroundButton: 'search-bg',
  sizeModal: 'lg',
  fontWeightTitleError: '600',
  image: './assets/images/Alert-icon.svg',
  showCancelButton: false,
  cancelButtonText: '',
  shortPadding: true,
};

/* Opciones del modal de restricción de conexión */
export const messageConnectionRestriction: OptsErrorModal = {
  showButton: false, // Ocultar botón de modal
  buttonCopy: 'modalBagsConnectionRestriction.button',
  showIconImage: false,
  urlIconImage: '',
  colorFontButton: 'white-font',
  backGroundButton: 'search-bg',
  sizeModal: 'sd',
  fontWeightTitleError: '600',
  image: './assets/images/img_no_ckn.svg',
  showCancelButton: false,
  cancelButtonText: '',
};

/* Opciones del modal de Baggage Only Flow - No CKI */
export const messageBaggageOnlyNoCki: OptsErrorModal = {
  showButton: true,
  buttonCopy: 'errorMsj.continue',
  showIconImage: false,
  urlIconImage: '',
  colorFontButton: 'white-font',
  backGroundButton: 'search-bg',
  sizeModal: 'sd',
  fontWeightTitleError: '600',
  image: './assets/images/img_no_ckn.svg',
  showCancelButton: false,
  cancelButtonText: '',
};

/* Opciones del modal de Baggage Only Flow - No Bags (conexión) */
export const messageBaggageOnlyNoBags: OptsErrorModal = {
  showButton: true,
  buttonCopy: 'errorMsj.continue',
  showIconImage: false,
  urlIconImage: '',
  colorFontButton: 'white-font',
  backGroundButton: 'search-bg',
  sizeModal: 'sd',
  fontWeightTitleError: '600',
  image: './assets/images/img_no_ckn.svg',
  showCancelButton: false,
  cancelButtonText: '',
};

/* Opciones del modal de Baggage Only Flow - Equipaje ya documentado */
export const messageBaggageOnlyCompleted: OptsErrorModal = {
  showButton: true,
  buttonCopy: 'errorMsj.continue',
  showIconImage: false,
  urlIconImage: '',
  colorFontButton: 'white-font',
  backGroundButton: 'search-bg',
  sizeModal: 'sd',
  fontWeightTitleError: '600',
  image: './assets/images/img_no_ckn.svg',
  showCancelButton: false,
  cancelButtonText: '',
};

export const messageDocumentationConnectionRestriction: OptsErrorModal = {
  showButton: false,
  buttonCopy: 'modalBagsConnectionDocumentationRestriction.button',
  showIconImage: false,
  urlIconImage: '',
  colorFontButton: 'white-font',
  backGroundButton: 'search-bg',
  sizeModal: 'sd',
  fontWeightTitleError: '600',
  image: './assets/images/img_no_ckn.svg',
  showCancelButton: false,
  cancelButtonText: '',
};

export const messageParamsTematic: OptsErrorModal = {
  backgroundColorModal: 'am-light',
  showButton: false,
  buttonCopy: 'errorMsj.continue',
  showIconImage: false,
  urlIconImage: '',
  colorFontButton: 'white-font',
  backGroundButton: 'search-bg',
  sizeModal: 'sd',
  fontWeightTitleError: '200',
  image: '',
  showCancelButton: false,
  cancelButtonText: '',
};

export const messageParamsUpdateDocuments: OptsErrorModal = {
  showButton: true,
  buttonCopy: 'modalUpdateDocuments.retry',
  showIconImage: false,
  urlIconImage: '',
  colorFontButton: 'white-font',
  backGroundButton: 'search-bg',
  sizeModal: 'sd',
  fontWeightTitleError: '600',
  image: '',
  showCancelButton: true,
  cancelButtonText: 'modalUpdateDocuments.exit',
};

export const messageRetry: OptsErrorModal = {
  showButton: true,
  buttonCopy: 'modalUpdateDocuments.retry',
  showIconImage: false,
  urlIconImage: '',
  colorFontButton: 'white-font',
  backGroundButton: 'search-bg',
  sizeModal: 'sd',
  fontWeightTitleError: '600',
  image: '',
  showCancelButton: false,
  cancelButtonText: 'modalUpdateDocuments.exit',
};

export function isNoItineraryError(error: any): boolean {
  return (
    error?.getMessage?.()?.includes('NO_ITINERARY') ||
    error?.getRaw?.()?.reason?.includes('NO_ITINERARY')
  );
}

export const messageNoItinerary: OptsErrorModal = {
  showButton: true,
  buttonCopy: 'continueCap',
  showIconImage: false,
  urlIconImage: '',
  colorFontButton: 'white-font',
  backGroundButton: 'search-bg',
  sizeModal: 'sd',
  fontWeightTitleError: '600',
  image: './assets/images/img_no_ckn.svg',
  showCancelButton: false,
  cancelButtonText: '',
};

export const ERRORS_CUSTOM_PASSPORT = {
  ONLY_ZEROS: 'onlyZeros',
  INVALID_CHARACTERS: 'invalidCharacters',
  INVALID_LENGTH: 'invalidLength',
  INVALID_PASSPORT_FORMAT: 'invalidPassportFormat',
};
